import './footer.css';
import './pages.css';
import {initSettingsLinks} from './gdprSettingsLink';

initSettingsLinks().catch();
